import { Component } from '@angular/core'

@Component({
	selector: 'app-system-forgot-password',
	templateUrl: './forgot-password.component.html',
	styleUrls: ['../style.component.scss'],
})
export class ForgotPasswordComponent {}
